import {
  UPDATE_OFFERS_DATA,
  HomePageActionTypes,
  IHomePageStoreState,
  TOGGLE_LOADING_GETOFFERS,
  UPDATE_HOME_SEO_DATA,
  UPDATE_CAMPAIGN_DATA,
  TOGGLE_LOADING_CAMPAIGN,
  UPDATE_HEAD_CAMPAIGN_DATA
} from './types';

const initialState: IHomePageStoreState = {
  offersApi: {
    isLoading: false,
    data: [],
  },

  homeSeoData: {
    h1: 'Hotel Booking',
    title: 'Online Hotel Booking | Book Cheap, Budget and Luxury Hotels -Goibibo',
  },

  campaignData: {
    isLoading: false,
    data: []
  }
};

export default function homePageReducer(state = initialState, action: HomePageActionTypes) {
  switch (action.type) {
    case UPDATE_HOME_SEO_DATA:
      return {
        ...state,
        homeSeoData: {
          ...action.homeSeoData,
        },
      };
    case UPDATE_OFFERS_DATA:
      return {
        ...state,
        offersApi: {
          ...state.offersApi,
          data: action.actionData,
        },
      };

    case UPDATE_CAMPAIGN_DATA:
      return{
        ...state,
        campaignData: {
          data: action.actionData,
        }
      }

    case TOGGLE_LOADING_GETOFFERS:
      return {
        ...state,
        offersApi: {
          ...state.offersApi,
          isLoading: action.actionData,
        },
      };

    case TOGGLE_LOADING_CAMPAIGN:
      return {
        ...state,
        campaignData: {
          ...state.campaignData,
          isLoading: action.actionData
        }
      }

    case UPDATE_HEAD_CAMPAIGN_DATA:
      return {
        ...state,
        campaignData: {
          ...state.campaignData,
          headData: action.actionData
        }
      }

    default:
      return state;
  }
}
